import React, { Component } from 'react';
import {
  View,
  StyleSheet,
  Modal,
  ImageBackground,
  ActivityIndicator,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import { observer } from 'mobx-react';

import Text from './Text';
import Image from './Image';
import Button from './Button';
import Message from './Message';
import Overlay from './Overlay';

import WarriorInfoModal from '../common/WarriorInfoModal';
import { PaperBackground, getScreenDimension } from '../Island/IslandScreen';

import {
  BASE_COLOR,
  PADDING,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
  SAFE_OFFSET,
  GOLDEN200,
  pOrT,
} from '../styleConstants';

import appStore from '../../stores/app';
import warriorInfoModalStore from '../common/WarriorInfoModal/store';

import {
  IS_WEB,
  IS_ANDROID,
  EVENT_CLOSE_MODAL,
  EVENT_ALL_MODALS_CLOSED,
  IS_PHONE,
} from '../../lib/appConstants';

export const styles = StyleSheet.create({
  line: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: 20,
    paddingRight: 20,
    borderStyle: 'solid',
    borderBottomColor: '#f3f3f4',
    borderBottomWidth: 1,
    height: 50,
  },
  container: {
    zIndex: 2,
    flex: 1,
    alignItems: 'center',
    // justifyContent: 'center',
    margin: 0,
    ...(IS_WEB && { boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.1)' }),
  },
  topActions: {
    position: 'absolute',
    zIndex: 99,
    left: 0,
    top: 0,
  },
  wrapper: {
    // justifyContent: 'center',
    // alignItems: 'center',
    flex: 1,
    // overflow: 'hidden',
    ...(IS_ANDROID
      ? {
          width: WINDOW_WIDTH,
          height: WINDOW_HEIGHT,
        }
      : null),
  },
  loading: {
    position: 'absolute',
  },
});

type Props = {
  onHide?: Function;
  children: any;
  onOk?: Function;
  okLabel?: string;
  onOkNext?: Function;
  okNextLabel?: string;
  title?: any;
  style?: any;
  fullScreen?: boolean;
  noMessage?: boolean;
  hideOverlay?: boolean;
  overlay?: boolean;
  onRequestClose?: Function;
  onShow?: Function;
  warriorListener?: boolean;
  onDismiss?: Function;
  onOkNextProps?: any;
  noFrame?: boolean;
  noTitle?: boolean;
  noBackgroundPaper?: boolean;
  size?: { width: number; height: number };
  marginTop?: number;
};

type State = {
  hoveredClose: boolean;
};

let openedModals = 0;

export const fullScreenSize = {
  width: 900,
  height: 600,
};

const SIZES = {
  default: pOrT(
    {
      width: 520,
      height: 340,
    },
    {
      width: 620,
      height: 440,
    },
  ),
};

export const NameFrame = ({
  fullScreen,
  title,
  center = true,
  style,
}: {
  fullScreen?: boolean;
  title: any;
  center?: boolean;
  style?: any;
}) => (
  <ImageBackground
    style={{
      left: '50%',
      top: fullScreen ? pOrT(22, 35) : 0,
      // top: 0,
      marginLeft: pOrT(-100, -150),
      width: pOrT(200, 300),
      height: pOrT(50, 75),
      position: 'absolute',
      alignItems: center ? 'center' : undefined,
      justifyContent: center ? 'center' : undefined,
      ...style,
    }}
    source={require('../../assets/images/nameFrame.png')}
  >
    {typeof title === 'string' ? (
      <Text
        bold
        style={{
          fontSize: pOrT(14, IS_WEB ? 15 : 16),
          color: GOLDEN200,
        }}
      >
        {title}
      </Text>
    ) : (
      title
    )}
  </ImageBackground>
);

@observer
export default class ModalWrapper extends Component<Props, State> {
  static defaultProps = {
    warriorListener: false,
  };

  index: number = 0;

  warriorInfoModalOpened = false;

  constructor(props: Props) {
    super(props);
    this.index = openedModals;
    this.state = {
      hoveredClose: false,
    };
  }

  componentDidMount() {
    openedModals += 1;
    const { hideOverlay } = this.props;
    if (!hideOverlay) appStore.toggleOverlay(true);

    (global as any).emitter.addListener(EVENT_CLOSE_MODAL, this.onEventClose);
  }

  componentWillUnmount() {
    const { onDismiss } = this.props;
    openedModals -= 1;

    (global as any).emitter.removeListener(EVENT_CLOSE_MODAL, this.onEventClose);
    if (openedModals === 0) appStore.toggleModalOpened(false);

    const { hideOverlay } = this.props;

    if (!hideOverlay && !openedModals) appStore.toggleOverlay(false);

    if (onDismiss) onDismiss();
  }

  onShow = () => {
    const { onShow } = this.props;

    if (onShow) onShow();

    if (openedModals === 1) appStore.toggleModalOpened(true);
  };

  onEventClose = () => {
    if (!IS_WEB && openedModals - 1 !== this.index) return;
    this.onRequestClose();

    if (IS_WEB) {
      (global as any).emitter.emit(EVENT_ALL_MODALS_CLOSED);
      return;
    }

    // TODO: mobile issue all modals should be closed before action delay workaround
    setTimeout(() => {
      if (openedModals > 0) {
        (global as any).emitter.emit(EVENT_CLOSE_MODAL);
      } else {
        (global as any).emitter.emit(EVENT_ALL_MODALS_CLOSED);
      }
    }, 700);
  };

  onRequestClose = () => {
    const { onRequestClose, onHide } = this.props;

    if (onRequestClose) onRequestClose();
    else if (onHide) onHide();
  };

  render() {
    const {
      onHide,
      children,
      onOk,
      onOkNext,
      okLabel,
      okNextLabel,
      onOkNextProps,
      title,
      style,
      noMessage,
      overlay,
      warriorListener,
      noFrame,
      noTitle,
      noBackgroundPaper,
      marginTop: marginTopProp,
    } = this.props;

    let { fullScreen } = this.props;

    let { size = SIZES.default } = this.props;
    const { hoveredClose } = this.state;
    let topActions = null;

    if (fullScreen && !IS_PHONE) {
      size = fullScreenSize;
      fullScreen = false;
    }

    if (fullScreen) {
      size = {
        width: !IS_ANDROID ? getScreenDimension().width : getScreenDimension().width - 40,
        height: !IS_ANDROID ? getScreenDimension().height : getScreenDimension().height - 40,
      };
    }

    const ModalComp: any = IS_WEB ? (global as any).ModalWeb : Modal;

    if (onHide || onOk) {
      topActions = (
        <View style={styles.topActions}>
          {onOk ? <Button onPress={onOk}>{okLabel}</Button> : null}
          {onOkNext ? (
            <Button style={{ marginTop: 10 }} onPress={onOkNext} {...onOkNextProps}>
              {okNextLabel}
            </Button>
          ) : null}
        </View>
      );
    }

    let marginTop = marginTopProp || Dimensions.get('window').height / 2 - size!.height / 2;
    if (fullScreen) {
      marginTop = PADDING + (IS_ANDROID ? 20 : 0);
    }

    const marginLeft = fullScreen
      ? SAFE_OFFSET + PADDING + (IS_ANDROID ? 20 : 0)
      : Dimensions.get('window').width / 2 - size!.width / 2;

    return (
      <ModalComp
        animationType="fade"
        transparent
        visible
        statusBarTranslucent
        supportedOrientations={['portrait', 'landscape']}
        onRequestClose={this.onRequestClose}
        appElement={IS_WEB ? document.getElementById('root') : undefined}
        onShow={this.onShow}
      >
        {!noFrame && (
          <PaperBackground
            width={size!.width}
            height={size!.height}
            noPaper={noBackgroundPaper}
            style={{
              marginLeft,
              marginTop: marginTop,
            }}
          />
        )}
        <View
          style={[
            styles.wrapper,
            {
              paddingTop: marginTop,
            },
          ]}
        >
          <View style={[styles.container, style]}>
            <View style={size}>
              {!noFrame && !noTitle && (
                <NameFrame
                  fullScreen={fullScreen}
                  style={{ marginTop: pOrT(-22, -35) }}
                  title={title}
                />
              )}
              <TouchableOpacity
                onPress={() => onHide && onHide()}
                style={{
                  right: 0,
                  top: 0,
                  width: pOrT(24, 28),
                  height: pOrT(24, 28),
                  position: 'absolute',
                  zIndex: 9,
                }}
                {...({
                  onMouseEnter: () => {
                    this.setState({ hoveredClose: true });
                  },
                  onMouseLeave: () => {
                    this.setState({ hoveredClose: false });
                  },
                } as any)}
              >
                <Image
                  style={{
                    width: pOrT(24, 28),
                    height: pOrT(24, 28),
                  }}
                  source={
                    hoveredClose
                      ? require('../../assets/images/closeOn.png')
                      : require('../../assets/images/close.png')
                  }
                />
              </TouchableOpacity>
              {topActions}
              <View style={{ flex: 1 }}>{children}</View>
            </View>
            {appStore.smallLoading && !appStore.loading && (
              <ActivityIndicator
                color={BASE_COLOR}
                style={[
                  styles.loading,
                  {
                    left: marginLeft + size!.width - 50,
                    top: 20,
                    // marginTop: noFrame ? -size.height / 2 + 5 : -size.height / 2 + 20,
                  },
                ]}
              />
            )}
          </View>
          {!noMessage && <Message modal />}
          {overlay || (appStore.loading && !IS_WEB) ? <Overlay loading={appStore.loading} /> : null}
        </View>
        {!IS_WEB &&
        (this.index === openedModals - 1 || this.warriorInfoModalOpened) &&
        warriorListener &&
        warriorInfoModalStore.warrior ? (
          <WarriorInfoModal
            onDismiss={() => {
              this.warriorInfoModalOpened = false;
            }}
            onShow={() => {
              this.warriorInfoModalOpened = true;
            }}
          />
        ) : null}
      </ModalComp>
    );
  }
}
